import type { CSSProperties } from "react";

export const CHARACTER_INSTRUCTION_PLACEHOLDERS_TEXT =
  "{{userOriginLanguage}}, {{userTargetLanguage}}, {{level}}";

export const CHARACTER_INSTRUCTION_PLACEHOLDERS_HINT_STYLE: CSSProperties = {
  marginBottom: 8,
  fontSize: 12,
  color: "rgba(0, 0, 0, 0.55)",
  lineHeight: 1.45,
};
